import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useAppContext } from "../context/AppContext";

export default function GlobalUnsavedChangesDialog() {
  const { pendingNavigation, confirmLeave, cancelLeave } = useAppContext();

  return (
    <Dialog
      open={Boolean(pendingNavigation)}
      onClose={cancelLeave}
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>
        Unsaved Changes
      </DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          You've made changes that haven't been saved yet. If you leave now, those changes will be lost.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={cancelLeave} variant="outlined">
          Stay on page
        </Button>
        <Button onClick={confirmLeave} variant="contained" color="error">
          Leave without saving
        </Button>
      </DialogActions>
    </Dialog>
  );
}
